/**
 * Redirects to the canonical Match Details route under the create flow.
 * Single entry point: /app/create/match-details/[gameId]
 */

import { useLocalSearchParams } from 'expo-router';
import { Redirect } from 'expo-router';

export default function MatchDetailsRedirectRoute() {
  const { gameId, homeTeam, awayTeam } = useLocalSearchParams<{
    gameId: string;
    homeTeam?: string;
    awayTeam?: string;
  }>();

  if (!gameId || typeof gameId !== 'string') {
    return <Redirect href="/app/create" />;
  }

  const params = new URLSearchParams();
  if (homeTeam != null && String(homeTeam)) params.set('homeTeam', String(homeTeam));
  if (awayTeam != null && String(awayTeam)) params.set('awayTeam', String(awayTeam));
  const query = params.toString();
  const href = query ? `/app/create/match-details/${gameId}?${query}` : `/app/create/match-details/${gameId}`;

  return <Redirect href={href as `/app/create/match-details/${string}`} />;
}
